"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VerticalLines = exports.Span = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var Span = _styledComponents["default"].span.withConfig({
  displayName: "VerticalLines__Span",
  componentId: "yl8u1u-0"
})(["height:100%;position:absolute;opacity:0.11;top:0;width:1px;", ""], function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      left = _ref.left;
  return (0, _styledComponents.css)(["background-color:", ";left:", ";"], backgroundColor, left);
});

exports.Span = Span;

var VerticalLines = function VerticalLines(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      count = _ref2.count;
  var numberOfLines = Number(count) + 1;

  var generateLeftProp = _react["default"].useCallback(function (value) {
    return "".concat(Number(100 / numberOfLines * value).toFixed(2), "%");
  }, [numberOfLines]);

  return !Number.isNaN(numberOfLines) ? _toConsumableArray(Array(numberOfLines).keys()).map(function (i) {
    return /*#__PURE__*/_react["default"].createElement(Span, {
      key: i,
      backgroundColor: backgroundColor,
      left: generateLeftProp(i)
    });
  }) : null;
};

exports.VerticalLines = VerticalLines;
VerticalLines.propTypes = {
  /**
   * CSS background color for the lines. Each will be rendered slightly transparent via opacity.
   */
  backgroundColor: _propTypes["default"].string,

  /**
   * Determines the number of vertical lines to generate.
   */
  count: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
VerticalLines.defaultProps = {
  backgroundColor: '#222',
  count: 4
};
var _default = VerticalLines;
exports["default"] = _default;